import { apiRequest } from '@/shared/api';

import type { Leaderboard } from '../model/types';

export function fetchWeeklyLeaderboard(): Promise<Leaderboard> {
  return apiRequest<Leaderboard>('/leaderboard/weekly');
}

export function fetchMonthlyLeaderboard(): Promise<Leaderboard> {
  return apiRequest<Leaderboard>('/leaderboard/monthly');
}
